module.exports = __webpack_public_path__ + "img/luxembourg.ea855e8.webp";